import React, { FC } from 'react';
import { Platform, DeviceType, AppView, Orientation } from 'sofa-reborn-react';
import { DivDeleteOverlay } from './DeleteOverlayStyle';
import { KompisIcon } from '@inter-ikea-kompis/react-components';
import { TrashCanIcon } from '@inter-ikea-kompis/icons';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

type Props = {
	deviceType: DeviceType;
	platform: Platform;
	orientation: Orientation;
	appView: AppView;
	pointerOverDragArea: boolean;
};

const DeleteOverlay: FC<Props> = (props) => {
	return (
		<DivDeleteOverlay
			pointerOverDropArea={props.pointerOverDragArea}
			orientation={props.orientation}
			deviceType={props.deviceType}
		>
			<KompisIcon
				theme={SkapaTheme}
				icon={TrashCanIcon || ''}
				// @ts-expect-error Kompis elemenets support style but it isn't exposed
				style={{
					margin: '0 auto',
					transform: props.pointerOverDragArea ? 'scale(3)' : 'scale(4)',
					transition: 'transform 0.3s ease-in-out',
				}}
			/>
		</DivDeleteOverlay>
	);
};

export default DeleteOverlay;
